import * as React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { NewCustomerList } from "src/components/dashboard-components/NewCustomers";
import { NewOrdersNumberCard } from "src/components/dashboard-components/NewOrders";
import PendingOrderList from "src/components/dashboard-components/PendingOrderItems";
import { RevenueGraph } from "src/components/dashboard-components/RevenueGraph";
import { IfCanAccess } from "src/enterprise/ra-rbac";

export default () => (
  <Box sx={{backgroundColor: "#f8f8f9"}}>
    <Typography variant="h3" component="h3" sx={{ marginLeft: "20px", marginTop: "20px" }}>
      Welcome!
    </Typography>
    <Box display="flex">
      <IfCanAccess action="show" resource="admin/orders">
        <RevenueGraph sx={{ width: "780px" }} />
      </IfCanAccess>
      <Box sx={{ width: "35%" }}>
        <IfCanAccess action="write" resource="admin/users.*">
          <NewCustomerList days={7} />
        </IfCanAccess>
      </Box>
    </Box>
    <Box display="flex">
      <Box sx={{ width: "30%" }}>
        <IfCanAccess action="show" resource="admin/orders">
          <NewOrdersNumberCard days={7} />
        </IfCanAccess>
        <IfCanAccess action="show" resource="admin/orders">
          <NewOrdersNumberCard days={30} />
        </IfCanAccess>
        <IfCanAccess action="show" resource="admin/orders">
          <NewOrdersNumberCard days={100} />
        </IfCanAccess>
      </Box>
      <IfCanAccess action="show" resource="admin/orders">
        <PendingOrderList sx={{ width: "40%" }} />
      </IfCanAccess>
    </Box>
  </Box>
);
